import { render, staticRenderFns } from "./EvaluationResult.vue?vue&type=template&id=9fbc9068&scoped=true&"
import script from "./EvaluationResult.vue?vue&type=script&lang=js&"
export * from "./EvaluationResult.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationResult.vue?vue&type=style&index=0&id=9fbc9068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbc9068",
  null
  
)

export default component.exports